import styled from 'styled-components';
import { Button } from 'lmc-ui-library';

export const SearchInputContainer = styled.div<any>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  ${(props) => props.containerWidth && `width: ${props.containerWidth};`}

  ${(props) =>
    props.fullWidth &&
    `
    & > div {
      width: 100%;
    }
  `}

  input {
    font-weight: bold;
  }

  @media (max-width: 425px) {
    width: calc(100% - 56px);
    gap: 8px;
  }
`;

export const SearchInputButton = styled(Button)<{ newUi: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 14px !important;
  padding-bottom: 14px !important;
  @media (max-width: 425px) {
    padding-left: 13px !important;
    padding-right: 13px !important;
    span {
      display: none;
    }
  }
  ${({ newUi }) =>
    newUi &&
    `
    font-family: var(--secondary-font-rebrand) !important;
    background-color: var(--color-indigo) !important;
    border-color: var(--color-indigo) !important;
    :hover {
         background-color: var(--color-indigo-t1) !important;
         border-color: var(--color-indigo-t1) !important;
         color: var(--color-indigo) !important;
         path {
          fill: var(--color-indigo);
        }
       },
  `}
`;

export const DroplistContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: 999;
  padding-top: 8px;
  top: 0;
  margin-top: 56px;
`;
